import React, {useEffect, useState} from 'react';
import {IParamsSearchNomenclature} from '../../../interfaces/fetch/Nomenclature';
import {Box, Button, Dialog, DialogContent, DialogTitle, IconButton} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import {DataGrid, GridColDef, GridRowsProp, GridCellParams, GridSelectionModel} from '@mui/x-data-grid';

interface INomenclatureSelectProps {
    isShow: boolean;
    setShow: React.Dispatch<React.SetStateAction<boolean>>;
    nomenclatures: any[];
    setInput: (params: IParamsSearchNomenclature) => void;
}

const NomenclatureSelect = ({isShow, setShow, nomenclatures, setInput}: INomenclatureSelectProps): React.JSX.Element => {
    const [selectedRow, setSelectedRow] = useState<any | null>(null);

    const handlerClose = () => {
        setShow(false);
    };

    const handleSelect = () => {
        if (selectedRow) {
            setInput(selectedRow);
            setShow(false);
        }
    };

    useEffect(() => {
        setSelectedRow(null);
    }, [nomenclatures]);

    const handleSelectionChange = (selection: GridSelectionModel) => {
        if (selection && selection.length > 0) {
            const selected = rows.find(row => row.barcode === selection[0]);
            setSelectedRow(selected || null);
        } else {
            setSelectedRow(null);
        }
    };

    const rows: GridRowsProp = nomenclatures;

    const columns: GridColDef[] = [
        {
            field: 'barcode',
            flex: 1,
            sortable: false,
            renderCell: (params: GridCellParams) => {
                const row = params.row;
                const parts = [row.barcode, row.name];

                if (row.vendor_code) {
                    parts.push(row.vendor_code);
                }
                if (row.price > 0.0 || row.wholesale_price > 0.0) {
                    parts.push(`${row.price}${row.wholesale_price > 0.0 ? '/' + row.wholesale_price : ''}`);
                }
                if (row.free_price) {
                    parts.push('✔');
                }
                if (row.tax_percent > 0.0) {
                    parts.push(`${row.tax_percent}%`);
                }
                if (row.measure_unit_name) {
                    parts.push(row.measure_unit_name);
                }
                if (row.marked_type_name) {
                    parts.push(row.marked_type_name);
                }

                return <Box sx={{lineHeight: 'normal', whiteSpace: 'normal'}}>{parts.join(', ')}</Box>;
            },
        },
    ];

    return (
        <Dialog open={isShow} onClose={handlerClose} fullWidth maxWidth="sm">
            <Box sx={{p: '20px 24px 10px 24px', position: 'relative', backgroundColor: '#f5f7ff'}}>
                <DialogTitle sx={{pr: 5}}>Выбор номенклатуры</DialogTitle>
                <IconButton
                    onClick={handlerClose}
                    sx={{
                        position: 'absolute',
                        right: 16,
                        top: 16,
                    }}
                >
                    <CloseIcon />
                </IconButton>
            </Box>
            <DialogContent>
                <DataGrid
                    rows={rows}
                    columns={columns}
                    getRowId={row => row.barcode}
                    pageSize={100}
                    rowsPerPageOptions={[100]}
                    disableColumnSelector
                    disableColumnFilter
                    disableColumnMenu
                    hideFooter
                    autoHeight
                    checkboxSelection={false}
                    onSelectionModelChange={handleSelectionChange}
                    sx={{
                        '& .MuiDataGrid-cell': {cursor: 'pointer'},
                    }}
                />
                <Box mt={2} display="flex" justifyContent="flex-end">
                    <Button variant="contained" onClick={handleSelect} disabled={!selectedRow}>
                        Выбрать
                    </Button>
                </Box>
            </DialogContent>
        </Dialog>
    );
};

export default NomenclatureSelect;
